import { AddressInput } from '@generated/gql/graphql';

import { ReferralFieldFormValues } from './attribution';
import { BooleanSelection } from './index';
import {
  FindStatus,
  IOTSCommunication,
  IOTSProvider,
  IOTSSwitchOption,
} from './oneTouchSwitching';

enum Title {
  Mr = 'Mr',
  Miss = 'Miss',
  Mrs = 'Mrs',
  Ms = 'Ms',
  Mx = 'Mx',
  Dr = 'Dr',
  Prof = 'Prof',
  Rev = 'Rev',
  Sir = 'Sir',
  Dame = 'Dame',
  Lord = 'Lord',
  Lady = 'Lady',
}

interface AboutYouFormValues {
  aboutNameTitle: Title;
  aboutNameFirst: string;
  aboutNameLast: string;
  aboutDoB: string;
  aboutContactNumber: string;
  aboutEmail: string;
  aboutAddressRecent?: BooleanSelection;
  aboutAddressPreviousOwner: BooleanSelection;
  aboutPreviousAddress?: Partial<AddressInput>;
}
interface YourAccountFormValues {
  yaPassword: string;
  yaAdditionalAccount: BooleanSelection;
  yaAdditionalAccountNameTitle: string;
  yaAdditionalAccountNameFirst: string;
  yaAdditionalAccountNameLast: string;
  yaAdditionalAccountDoB: string;
  yaAdditionalAccountContactNumber: string;
  yaAdditionalAccountEmail: string;
  yaSecondCbcAccount: BooleanSelection;
  yaSecondCbcNameTitle: string;
  yaSecondCbcUseDetails: BooleanSelection;
  yaSecondCbcNameFirst: string;
  yaSecondCbcNameLast: string;
  yaSecondCbcDoB: string;
  yaSecondCbcContactNumber: string;
  yaSecondCbcEmail: string;
}
interface DirectDebitFormValues {
  ddName: string;
  ddSortCode: string;
  ddAccountNumber: string;
  ddBillingSame: BooleanSelection;
  ddBillingAddress?: AddressInput;
  ddBillingAddressForm?: Partial<AddressInput>;
}

interface BroadbandFormValues {
  broadbandEmergMonitDevice?: BooleanSelection;
  broadbandEmergAlt?: BooleanSelection;
}

interface OTSFormValues {
  otsHasExistingLine: boolean;
  otsProviderNotListed: boolean;
  otsSelectedProvider: IOTSProvider | null;
  otsFindStatus: FindStatus;
  otsComms: IOTSCommunication[];
  otsHomePhoneSuffix: string | null;
  otsAccountReference: string;
  otsBroadbandReference: string;
  otsHomePhoneReference: string | null;
  otsFieldErrors: string[];
  otsMatchId: string | null;
  otsSwitchingReference: string | null;
  otsSwitchOptions: IOTSSwitchOption[];
  otsSurname?: string;
}

interface ReferralLegalFormValues extends ReferralFieldFormValues {
  rlAcceptMarketing: BooleanSelection;
  rlTermsAccept: BooleanSelection;
}

interface ContractRenewalFormValues {
  renewalBroadbandDate?: Nullable<string>;
  renewalMobileDate?: Nullable<string>;
  renewalHomeInsuranceDate?: Nullable<string>;
  renewalCarInsuranceDate?: Nullable<string>;
}

type YourDetailsFormValues = AboutYouFormValues &
  YourAccountFormValues &
  DirectDebitFormValues &
  BroadbandFormValues &
  OTSFormValues &
  ReferralLegalFormValues &
  ContractRenewalFormValues;

export { Title };
export type {
  AboutYouFormValues,
  YourAccountFormValues,
  DirectDebitFormValues,
  ReferralLegalFormValues,
  YourDetailsFormValues,
  BroadbandFormValues,
  OTSFormValues,
  ContractRenewalFormValues,
};
